import * as React from "react";
import { QrcodeCanvas, useQrcodeDownload } from "react-qrcode-pretty";
import { TicketSummary } from "../utils/TicketService";

interface TicketCardProps {
    ticket: TicketSummary;
}

const TicketCard: React.FC<TicketCardProps> = ({ ticket }: TicketCardProps) => {
    const statusLabel = ticket.redeemed ? "Used" : "Active";
    const statusColor = ticket.redeemed ? "bg-gray-200 text-gray-700" : "bg-green-100 text-green-800";

    return (
        <div className="bg-white shadow rounded-lg p-6 flex flex-col md:flex-col md:items-center md:justify-between gap-6">
            <div className="flex-1 space-y-2">
                <div className="flex items-center gap-3">
                    <span className={`text-xs font-semibold uppercase tracking-wide px-3 py-1 rounded ${statusColor}`}>{statusLabel}</span>
                    {ticket.campaignName && <span className="text-sm text-gray-500">{ticket.campaignName}</span>}
                </div>
                <h3 className="text-xl font-semibold">{ticket.name}</h3>
                <div className="text-sm text-gray-600">
                    <span className="font-medium">Ticket key:</span> {ticket.voucherKey}
                </div>
                {ticket.notified && <div className="text-xs text-blue-600">Notification sent</div>}
            </div>
            <div className="w-full md:w-auto md:pl-6 flex justify-center">
                {ticket.code ? (
                    <div className="bg-white p-3 border rounded">
                        <QrcodeCanvas
                            value={ticket.code || ""}
                            variant={{
                                eyes: "gravity",
                                body: "fluid",
                            }}
                            color={{
                                eyes: "#DB1C7D",
                                body: "#DB1C7D",
                            }}
                            image={{
                                src: "/images/logo.png",
                            }}
                            padding={10}
                            margin={10}
                            bgColor="#ffffff"
                            bgRounded
                            divider
                            size={250}
                        />
                        <p className="text-xs text-center text-gray-500 mt-2">Present this code at the entrance</p>
                    </div>
                ) : (
                    <div className="text-sm text-gray-500">QR code unavailable for this ticket.</div>
                )}
            </div>
        </div>
    );
};

export default TicketCard;
